import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { ProgressBarStriped } from '@/components/ProgressBarStriped/ProgressBarStriped';
import type { CouponCreateProgressProps } from './CouponCreateProgress.types';
import styles from './CouponCreateProgress.module.scss';
const CouponCreateProgress: FC<CouponCreateProgressProps> = ({
  duration = 10000,
  size = 'small'
}) => {
  const {
    t
  } = useTranslation('sport');
  const [progress, setProgress] = useState(0);
  const timer = useRef(0);
  useEffect(() => {
    const startTime = Date.now();
    timer.current = window.setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(duration - elapsedTime, 0);
      const percentage = (duration - remainingTime) / duration * 100;
      setProgress(percentage);
      if (remainingTime <= 0) {
        clearInterval(timer.current);
      }
    }, 100);
    return () => clearInterval(timer.current);
  }, [duration]);
  return <div className={styles.root} data-sentry-component="CouponCreateProgress" data-sentry-source-file="CouponCreateProgress.tsx">
      <ProgressBarStriped className={cn(styles.progress, styles[size])} percent={progress} value={t('coupon.bet_creation', 'Bet slip creation')} showValue data-sentry-element="ProgressBarStriped" data-sentry-source-file="CouponCreateProgress.tsx" />
    </div>;
};
export { CouponCreateProgress };